import {ApckPortletCardPanel} from "../portlet";

export const ApckPortletTotalScans = /*#__PURE__*/ ApckPortletCardPanel.extend({
    props: {
        ctype: {
            type: String,
            default: "totalscansportlet"
        },
        title: {
            type: String,
            default: "Total Scans"
        },
        size: {
            type: String,
            default: "sm"
        },
        description: {
            type: String,
            default: "Counter showing the total number of running scans"
        },
        src: {
            type: String,
            default: "/totalscans"
        },
    },
});
